import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button } from './../../common/Forms';
import { PublicRoutes } from './../../common/PublicRoutes';
import Codi from './assets/dino-face.png';
import Hex2 from './assets/2.svg';
import Hex3 from './assets/3.svg';

const CompetitionLogicBook1 = () => {
    const { code } = useParams();
    const competitionKey = 'b57efdb5-d4df-4ea8-ad9b-e487ccea66da';

    return (
        <div
            class="bg-no-repeat bg-contain bg-left-bottom flex flex-col h-screen justify-between"
            style={{
                backgroundImage: `url(${Codi})`,
            }}
        >
            <header>
                <img className="mx-auto" src={Hex2} alt="" />
            </header>
            <main className="block p-8 mb-auto">
                {code === competitionKey ? (
                    <div>
                        <h1 className="text-center text-orange text-3xl lg:text-5xl xl:text-6xl font-yerevan leading-none mb-10 lg:mb-20">
                            Շնորհավորո՜ւմ ենք
                        </h1>
                        <p className="text-center font-mardoto-medium text-gray-800 pb-12 text-s lg:text-lg xl:text-xl">
                            Դուք ունեք 5% զեղչ մեր ուսումնական կենտրոնի դասընթացներին մասնակցելու
                            համար։
                        </p>
                    </div>
                ) : (
                    <div>
                        <h1 className="text-center text-orange text-3xl lg:text-5xl xl:text-6xl font-yerevan leading-none mb-10 lg:mb-20">
                            Ողջո՜ւյն բարեկամ
                        </h1>
                        <p className="text-center font-mardoto-medium text-gray-800 pb-12 text-s lg:text-lg xl:text-xl">
                            Եթե դու ինձ պես սրամիտ ես, հետաքրքրասեր ու ընդունակ և էլ ավելի ես
                            ցանկանում զարգացնել գիտելիքներդ ու հմտություններդ, ապա դու ճի՛շտ հասցեով
                            ես դիմել։
                            <br /> Ես քեզ կօգնեմ ճիշտ կողմնորոշվել և լուծել ցանկացած խնդիր՝ հնարավոր
                            ամենաարագ և արդյունավետ ճանապարհով։
                            <br /> <br /> Դե ինչ։ Սկսեցի՜նք․․․
                        </p>
                    </div>
                )}
                <div className="flex flex-wrap justify-center items-center">
                    <Link to={`${PublicRoutes.Contact}/knowMore`}>
                        <Button>Իմանալ ավելին</Button>
                    </Link>
                </div>
            </main>
            <footer>
                <img className="ml-auto mr-0" src={Hex3} alt="" />
            </footer>
        </div>
    );
};

export default CompetitionLogicBook1;
